const SRC = {
  corner: "/leaves-corner.png",
  side: "/leaves-side.png",
  bunch: "/plantain-bunch.png",
};

// Decorative botanical leaf layers for the light sections.
export default function LeafDecor({ layers = [] }) {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      {layers.map((l, i) => (
        <img
          key={i}
          src={SRC[l.img]}
          alt=""
          style={{ opacity: Math.min(1, (l.opacity ?? 0.13) * 1.8), filter: "saturate(1.6) brightness(0.6) contrast(1.08)" }}
          className={"absolute select-none " + (l.className || "")}
        />
      ))}
    </div>
  );
}
